const SEO = {
  defaultTitle: 'Sushi',
  titleTemplate: '%s | Sushi',
  description: 'Swap, yield, lend, borrow, leverage, limit, launch all on one community driven ecosystem',
  openGraph: {
    type: 'website',
    url: 'https://app.sushi.com/',
    site_name: 'Sushi',
  },
  twitter: {
    handle: '@SushiSwap',
    site: '@SushiSwap',
    cardType: 'summary_large_image',
  },
}

export default SEO
